import React, { Component } from "react";
import {
  View,
  TouchableOpacity,
  Image,
  Dimensions,
  Pressable,
  ScrollView,
  ImageBackground,
} from "react-native";
import Checkbox from "expo-checkbox";
import * as Animatable from "react-native-animatable";
import { White, WHITE } from "react-native-material-color";
// import DocumentPicker from 'react-native-document-picker';


// import ActionSheet from 'react-native-actionsheet';

import * as Styles from "../utils/Styles";
import * as Commons from "../utils/Commons";
import * as Constants from "../utils/Constants";
import { STRINGS } from "../utils/Strings";
import Header from "../components/Header";
import Text from "../components/Text";
import * as ServerOperations from "../utils/ServerOperations";
import { Dropdown } from "react-native-element-dropdown";
import moment from "moment";
// import * as FileSystem from 'expo-file-system';

let height = Dimensions.get("window").height;
let width = Commons.getWidth();
let marginTop = 0;
let styles = {};
let brandPos = 1;
let brandFlag = 1;
let isMobile = false;
const xIcon = require("../images/x.png");
const arrowRight = require("../images/arrowright.png");
const arrowRight2 = require("../images/arrowright2.png");
const jo1 = require("../images/home/jo1.png");
const jo2 = require("../images/home/jo2.png");
const jo3 = require("../images/home/jo3.png");
const jo4 = require("../images/home/jo4.png");
const jo5 = require("../images/home/jo5.png");
const imgCareers = require("../images/Careers/careersimg.png.jpeg");
const imgCareersMobile = require("../images/Careers/mobile_careersimg.png.jpeg");
const imgLocation = require("../images/location.png");
const imgDepartment = require("../images/department.png");
const imgModality = require("../images/modality.png");
const imgSalary = require("../images/salary.png");
let scale = 1;
const joImgs = [jo1, jo2, jo3, jo4, jo5]
const brandsImageSize = {}
const dropDownListItems = [{
  label: 'Finance', value: 'Finance'
},
{ label: 'Sales & Marketing', value: 'Sales & Marketing' },
{ label: 'HR', value: 'HR' },
{ label: 'Regulatory Affairs', value: 'Regulatory Affairs' },
{ label: 'Quality', value: 'Quality' },
{ label: 'Storage & Distribution', value: 'Storage & Distribution' },
{ label: 'IT', value: 'IT' },
{ label: 'Others', value: 'Others' },
];
class Careers extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isScrolled: false,
      brands: [],
      joImgPos: 0,
      hideScrollTopButton: true,
      jobOpenings: [],
      jobOpeningPos: 0,
      department: '',
      showjobDetailsDialog: false
    };
  }
  Pressables = {};

  async componentDidMount() {
    const jobOpenings = await ServerOperations.getJobOpening();
    this.setState({ jobOpenings });
  }


  renderPressableButton = (componentRef, text, onPress, textStyle) => {
    const isHovered = this.state.hoveredComponent && this.Pressables[componentRef] == this.state.hoveredComponent;
    return (
      <Pressable
        disabled={!this.state.fileToUpload || !this.state.department || !this.state.agree}
        ref={el => (this.Pressables[componentRef] = el)}
        onHoverIn={() => this.setState({ hoveredComponent: this.Pressables[componentRef] })}
        onHoverOut={() => this.setState({ hoveredComponent: undefined })}
        style={{ justifyContent: 'center', alignItems: 'center' }}>
        <TouchableOpacity onPress={onPress} style={[isHovered ? Styles.ButtonStyleCareerHovered : Styles.ButtonStyleCareer, isMobile && { width: width - 40 }]}>
          <Text style={isHovered ? [Styles.TextStyle2, { fontSize: 16, color: 'white' }, textStyle] : [Styles.TextStyle2, { fontSize: 16, color: Styles.appColor2 }, textStyle]}>{text}</Text>
        </TouchableOpacity>
      </Pressable>
    )
  }


  renderApplyCvButton = (componentRef, text, onPress, textStyle) => {
    const isHovered = this.state.hoveredComponent && this.Pressables[componentRef] == this.state.hoveredComponent;
    return (
      <Pressable
        disabled={!this.state.cvToUpload}
        ref={el => (this.Pressables[componentRef] = el)}
        onHoverIn={() => this.setState({ hoveredComponent: this.Pressables[componentRef] })}
        onHoverOut={() => this.setState({ hoveredComponent: undefined })}
        style={{ justifyContent: 'center', alignItems: 'center' }}>
        <TouchableOpacity onPress={onPress}
          style={[isHovered ? Styles.ButtonStyleCareerHovered : Styles.buttonStyleCareer2, isMobile && { width: width - 40 }]}>
          <Text style={isHovered ? [Styles.TextStyle2, { fontSize: 16, color: 'white' }, textStyle] : [Styles.TextStyle2, { fontSize: 16, color: Styles.appColor2 }, textStyle]}>{text}</Text>
        </TouchableOpacity>
      </Pressable>
    )
  }



  renderPressableButton2 = (componentRef, text, onPress) => {
    const isHovered = this.state.hoveredComponent && this.Pressables[componentRef] == this.state.hoveredComponent;
    return (
      <Pressable
        ref={el => (this.Pressables[componentRef] = el)}
        onHoverIn={() => this.setState({ hoveredComponent: this.Pressables[componentRef] })}
        onHoverOut={() => this.setState({ hoveredComponent: undefined })} >
        <TouchableOpacity onPress={onPress} style={isHovered ? Styles.ButtonStyleHovered : Styles.ButtonStyle}>
          <Text style={isHovered ? Styles.ButtonTextStyleHovered : Styles.ButtonTextStyle}>{text}</Text>
        </TouchableOpacity>
      </Pressable>
    )
  }

  renderPressableLink = (text, textStyle, onPress) => {
    const componentRef = text;
    const isHovered = this.state.hoveredComponent && this.Pressables[componentRef] == this.state.hoveredComponent;
    const color = isHovered ? '#52c0ee' : '#3B627F';
    return (
      <Pressable
        ref={el => (this.Pressables[componentRef] = el)}
        onHoverIn={() => this.setState({ hoveredComponent: this.Pressables[componentRef] })}
        onHoverOut={() => this.setState({ hoveredComponent: undefined })} >
        <TouchableOpacity onPress={onPress} style={{
          flexDirection: "row", alignSelf: "flex-start", alignItems: "center", justifyContent: "center", gap: 8,
          border: '1.5px solid transparent',
          borderBottomColor: color
        }}>
          <Text style={[Styles.TextStyle2, isHovered && { color }, textStyle, {
            fontSize: 15
          }]}>{text}</Text>
          <Image source={isHovered ? arrowRight2 : arrowRight} style={{ height: 12, width: 14, marginBottom: -2 }} resizeMode="contain" />
        </TouchableOpacity>
      </Pressable>
    )
  }


  renderMobile() {
    scale = width / 420;
    if (scale > 1) scale = 1;
    return (
      <View style={styles.container}>
        <Header
          title={STRINGS.company_name}
          leftView={Styles.drawerButtonDark(this.props.navigation)}
          light={true}
          navigation={this.props.navigation}
          hideHeader={this.state.hideHeader}
          hideScrollTopButton={this.state.hideScrollTopButton}
          self={this}
          selectedTab={""}
        />
        {this.renderJobDialog()}
        {Commons.loadFonts(this)}
        <ScrollView
          ref={ref => this.mainScrollView = ref}
          scrollEventThrottle={200} showsVerticalScrollIndicator={false} onScroll={(e) => Commons.onHeaderScroll(e, this)}>
          <View style={{ width, paddingHorizontal: 20, gap: 50 }}>
            {Styles.renderVSeparator(39)}
            {this.renderPart1Mobile()}
            {this.renderPart2Mobile()}
            {this.renderPart4Mobile()}
            {Commons.renderFooter({}, this)}
          </View>
        </ScrollView >
      </View>
    );
  }

  render() {
    Commons.resizeHandle(window, this, () => {
      width = this.width;
      height = this.height;
    });
    width = Dimensions.get("window").width;
    isMobile = Commons.isMobile();
    if (isMobile) {
      styles = this.styles();
      return this.renderMobile();
    }
    width = Commons.getWidth();
    styles = this.styles();
    marginTop = 290 - (Constants.MAX_WIDTH - width) * 0.3
    return (
      <View style={styles.container}>
        <Header
          title={STRINGS.company_name}
          leftView={Styles.drawerButtonDark(this.props.navigation)}
          light={true}
          navigation={this.props.navigation}
          hideHeader={this.state.hideHeader}
          hideScrollTopButton={this.state.hideScrollTopButton}
          self={this}
          selectedTab={"Careers"}
        />
        {this.renderJobDialog()}
        <ScrollView
          ref={ref => this.mainScrollView = ref}
          scrollEventThrottle={200} showsVerticalScrollIndicator={false} onScroll={(e) => Commons.onHeaderScroll(e, this)}>
          {Commons.loadFonts(this)}
          {this.renderPart1()}
          {this.renderPart2()}
          {this.renderPart4()}
          {/* {this.renderPart5()} */}
          {/* {this.renderPart6()} */}
          {Commons.renderFooter({}, this)}
        </ScrollView >

      </View >
    );
  }


  renderPart1 = () => {
    return (<ImageBackground style={{
      width: width,
      height: width / 2.545,
      marginTop: 100,
      justifyContent: 'center',
      alignItems: 'center',
    }}
      source={imgCareers}>
      <View style={{
        alignItems: "center",
        backgroundColor: 'rgba(128,128,128,0.5)',
        justifyContent: 'center',
        width: width,
        height: width / 2.54,
        position: 'absolute',
        flexDirection: 'column',
        gap: 30,
      }}>
        <Text style={[Styles.TextStyle1, { letterSpacing: 1, fontSize: 43.95, color: 'white' }]}>Join Our Team!</Text>
        <Text style={[Styles.TextStyle2, { fontSize: 22.5, color: 'white', }]}>We're excited that you're considering joining our
          {'\n'}                              dedicated team.</Text>
      </View>
    </ImageBackground>

    )
  }

  renderPart1Mobile = () => {
    return (
      <ImageBackground source={imgCareersMobile} style={{
        width,
        marginLeft: -20,
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'left',
        marginTop,
        height: width * 0.6351
      }} resizeMode="cover">
        <View style={{
          alignItems: "flex-start",
          backgroundColor: 'rgba(128,128,128,0.75)',
          justifyContent: 'center',
          flexDirection: 'column',
          gap: 30,
          width: width,
          paddingHorizontal: 20,
          paddingTop: 2 * 50 * scale,
          paddingBottom: 50 * scale,
          height: width * 0.6351
        }}>
          <Text style={[Styles.TextStyle3, { letterSpacing: 1, color: 'white', }]}>Join Our Team!</Text>
          <Text style={[Styles.TextStyle2, { color: 'white', letterSpacing: 0.08 }]}>We appreciate your interest and are here to assist
            {'\n'}with any inquiries you might have!</Text>
        </View>
      </ImageBackground>
    )
  }

  setJobDescriptionView = (key) => {
    this.setState({ showjobDetailsDialog: true, jobOpeningPos: key });
    setTimeout(() => {
      this.jobDetailsDialog.animate({ 0: { opacity: 0 }, 1: { opacity: 1 } }, 350);
    }, 300);
  }

  renderPart2 = () => {
    const jobItems = this.state.jobOpenings.map(
      (item, index) => {
        const isSelected = this.state.jobOpeningPos == index;
        return (
          <View style={{
            width: width - 164 * 2 - 30,
            height: 103.444,
            justifyContent: 'center',
            alignItems: 'flex-start',
            boxShadow: '15.556px 15.556px 15.556px 0px rgba(0, 0, 0, 0.45)',
            borderRadius: 38.889,
            marginLeft: width * 0.1,
          }}>
            <View style={{ flexDirection: 'row', width: '100%', justifyContent: "space-between", alignItems: 'center' }}>
              <View style={{ flexDirection: 'column', gap: 5, marginLeft: 60, width: 250 }}>
                <Text style={[Styles.TextStyle1, { fontSize: 18.5, lineHeight: 1.6 * 18.5 }]}>{item.JOBTITLE}</Text>
                <View style={{ flexDirection: 'row', gap: 10 }}>
                  <Text style={[Styles.TextStyle2, { fontSize: 12 }]}>{item.DEPARTMENT}</Text>
                  <Text style={[Styles.TextStyle2, { fontSize: 12, color: '#52C0EE' }]}>{item.LOCATION}</Text>
                </View>
              </View>
              <Text style={[Styles.TextStyle2, { fontSize: 18.5, width: 200 }]}>{item.DATE}</Text>
              <View style={{ marginRight: 50 }}>
                {this.renderPressableButton2(item.JOBTITLE, 'Learn More', () => this.setJobDescriptionView(index))}
              </View>
            </View>


          </View>
        )
      }
    );
    return (<View style={{
      display: 'flex',
      width: width,
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: "flex-start",
      gap: 30,
      marginTop: 120,
    }}>
      {this.state.jobOpenings != '' && (
        <View style={{ gap: 39 }}>
          <Text style={[Styles.TextStyle3, { marginLeft: width * 0.1 }]}>Job Openings</Text>
          {jobItems}
        </View>
      )}
      {this.state.jobOpenings == '' && (
        <View style={{ flexDirection: 'column', gap: 20 }}>
          <Text style={[Styles.TextStyle3, { marginLeft: width * 0.1 }]}>Job Openings</Text>
          <Text style={[Styles.TextStyle2, { marginLeft: width * 0.1 }]}>Currently,there are no job openings available</Text>
        </View>
      )}
    </View>)
  }

  renderPart2Mobile = () => {
    const jobItems = this.state.jobOpenings.map(
      (item, index) => {
        const isSelected = this.state.jobOpeningPos == index;
        return (
          <TouchableOpacity style={{
            width: width - 40,
            justifyContent: 'center',
            alignItems: 'flex-start',
            borderWidth: 0.5,
            borderColor: Styles.appColor3,
            borderRadius: 38,
          }}
            onPress={() => this.setJobDescriptionView(index)}>
            <View style={{
              flexDirection: 'row', width: '100%', height: 70,
              justifyContent: "space-between", alignItems: 'center', paddingLeft: 42
            }}>
              <View style={{ flexDirection: 'column', gap: 5 }}>
                <Text style={[Styles.TextStyle1, { fontSize: 17.5 * scale, width: 200 * scale }]}>{item.JOBTITLE}</Text>
                <View style={{ flexDirection: 'row', gap: 10 }}>
                  <Text style={[Styles.TextStyle2, { fontSize: 8.96 * scale }]}>{item.DEPARTMENT}</Text>
                  <Text style={[Styles.TextStyle2, { fontSize: 8.96 * scale, color: '#52C0EE' }]}>{item.LOCATION}</Text>
                </View>
              </View>
              <Text style={[Styles.TextStyle2, { fontSize: 12.44 * scale, width: 200 * scale }]}>{item.DATE}</Text>
            </View>
          </TouchableOpacity>
        )
      }
    );
    return (<View style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: "flex-start",
      gap: 30,
      backgroundColor: WHITE,
    }}>
      {this.state.jobOpenings != '' && (
        <View style={{ gap: 24 }}>
          <Text style={[Styles.TextStyle3, { marginLeft: 20 }]}>Job Openings</Text>
          <View style={{ gap: 12 }}>
            {jobItems}
          </View>
        </View>
      )}
      {this.state.jobOpenings == '' && (
        <View style={{ flexDirection: 'column', gap: 20 }}>
          <Text style={[Styles.TextStyle3, { marginLeft: 20 }]}>Job Openings</Text>
          <Text style={[Styles.TextStyle2, { marginLeft: 20 }]}>Currently,there are no job openings available</Text>
        </View>
      )}
    </View>)

  }

  closeJobDialog = () => {
    this.jobDetailsDialog.animate({ 0: { opacity: 1 }, 1: { opacity: 0 } }, 250);
    setTimeout(() => {
      this.setState({ showjobDetailsDialog: false });
    }, 500);
  }

  renderJobDialog = () => {
    if (isMobile) return this.renderJobDialogMobile();
    if (this.state.jobOpenings.length == 0) {
      return <View></View>;
    }
    const item = this.state.jobOpenings[this.state.jobOpeningPos];
    const lines = item.DUTIES.split('#^');
    const qualificationsLines = item.QUALIFICATIONS.split('#^');
    const SkillsLines = item.SKILLS.split('#^');
    let zoom = (Dimensions.get("window").width > Constants.MAX_WIDTH && false ? Constants.MAX_WIDTH : Dimensions.get("window").width) / Constants.MAX_WIDTH
    if (zoom > 1.25) zoom = 1.25;
    return (
      <Animatable.View
        ref={el => (this.jobDetailsDialog = el)}
        style={[{
          opacity: 0, position: "fixed",
          zIndex: this.state.showjobDetailsDialog ? 9 : 0, width: '100%', height: '100%',
          background: 'rgba(59, 98, 127, 0.50)'
        }]}>

        <Pressable style={{
          flex: 1, alignItems: 'center',
          justifyContent: 'center',
          cursor: ''
        }} onPress={this.closeJobDialog}>

          <Pressable style={{
            cursor: ''
          }} >
            {!isMobile && (
              <TouchableOpacity onPress={this.closeJobDialog} style={{ position: "absolute", zIndex: 999, right: 65, top: 65 }}>
                <Image source={xIcon} style={{ height: 15, width: 15 }} />
              </TouchableOpacity>
            )}

            <ScrollView
              ref={ref => this.mainScrollView = ref}
              style={{ height: isMobile ? 500 : height / zoom - 100 }}
              scrollEventThrottle={200} showsVerticalScrollIndicator={true}
            >
              <Animatable.View style={{ backgroundColor: White, width: isMobile ? Constants.MOBILE_WIDTH - 380 : 910, padding: 65, marginTop: isMobile ? 280 : undefined }} >
                {isMobile && (
                  <TouchableOpacity onPress={this.closeJobDialog} style={{ position: "absolute", zIndex: 999, right: 65, top: 25 }}>
                    <Image source={xIcon} style={{ height: 15, width: 15 }} />
                  </TouchableOpacity>
                )}
                <View style={{ flexDirection: 'column', gap: 56 }}>
                  <View style={{ flexDirection: 'column', gap: 26 }}>
                    <Text style={[Styles.TextStyle3, { fontSize: 28 }]}>{item.JOBTITLE}</Text>
                    <View style={{ flexDirection: 'row', gap: isMobile ? 50 : 76 }}>
                      <View style={{ flexDirection: 'column', gap: 13 }}>
                        <View style={{ flexDirection: 'row', gap: 10, alignItems: "center" }}>
                          <Image source={imgLocation} style={{ height: isMobile ? 7.703 : 11.89, width: isMobile ? 6.029 : 9.305 }} resizeMode="contain" />
                          <Text style={[Styles.TextStyle2, { fontSize: isMobile ? 10.366 : 16, fontWeight: '400', letterSpacing: 0.08 }]}>Location</Text>
                        </View>
                        <Text style={[Styles.TextStyle2, { fontSize: isMobile ? 10.366 : 16, fontWeight: '700', width: isMobile ? 60 : 120 }]}>{item.LOCATION}</Text>
                      </View>

                      <View style={{ flexDirection: 'column', gap: 13 }}>
                        <View style={{ flexDirection: 'row', gap: 10, alignItems: "center" }}>
                          <Image source={imgDepartment} style={{ height: isMobile ? 6.67 : 10.296, width: isMobile ? 8.952 : 13.817 }} resizeMode="contain" />
                          <Text style={[Styles.TextStyle2, { fontSize: isMobile ? 10.366 : 16, fontWeight: '400', letterSpacing: 0.08 }]}>Department</Text>
                        </View>
                        <Text style={[Styles.TextStyle2, { fontSize: isMobile ? 10.366 : 16, fontWeight: '700', width: isMobile ? 60 : 120 }]}>{item.DEPARTMENT}</Text>
                      </View>

                      <View style={{ flexDirection: 'column', gap: 13 }}>
                        <View style={{ flexDirection: 'row', gap: 10, alignItems: "center" }}>
                          <Image source={imgModality} style={{ height: isMobile ? 7.659 : 11.822, width: isMobile ? 7.404 : 11.428 }} resizeMode="contain" />
                          <Text style={[Styles.TextStyle2, { fontSize: isMobile ? 10.366 : 16, fontWeight: '400', letterSpacing: 0.08 }]}>Modality</Text>
                        </View>
                        <Text style={[Styles.TextStyle2, { fontSize: isMobile ? 10.366 : 16, fontWeight: '700', width: isMobile ? 60 : 120 }]}>{item.MODALITY}</Text>
                      </View>
                      <View style={{ flexDirection: 'column', gap: 13 }}>
                        <View style={{ flexDirection: 'row', gap: 10, alignItems: "center" }}>
                          <Image source={imgSalary} style={{ height: isMobile ? 8.317 : 12.838, width: isMobile ? 13.055 : 20.15 }} resizeMode="contain" />
                          <Text style={[Styles.TextStyle2, { fontSize: isMobile ? 10.366 : 16, fontWeight: '400', letterSpacing: 0.08 }]}>Salary</Text>
                        </View>
                        <Text style={[Styles.TextStyle2, { fontSize: isMobile ? 10.366 : 16, fontWeight: '700', width: isMobile ? 60 : 120 }]}>{item.SALARY}</Text>
                      </View>

                    </View>


                    {/* jobDescription view */}
                    <View style={{ flexDirection: 'column', gap: 34, marginTop: 40 }}>
                      <Text style={[Styles.TextStyle1, { fontSize: 22 }]}>Job Description</Text>
                      <View style={{ flexDirection: 'column', gap: 0 }}>
                        <Text style={[Styles.TextStyle2, { fontSize: 16, fontWeight: '700' }]}>Duties & Responsibilities:</Text>
                        {lines.map((line, index) => (
                          <View style={{ flexDirection: "row", width: '90%' }}>
                            <Text style={[Styles.TextStyle2, { fontSize: 16, marginLeft: 5 }]} key={index}>{'\u2022'}</Text>
                            <Text style={[Styles.TextStyle2, { fontSize: 16, marginLeft: 8.5 }]}>{line.trim()}</Text>
                          </View>
                        ))}
                      </View>

                      <View style={{ flexDirection: 'column', gap: 0 }}>
                        <Text style={[Styles.TextStyle2, { fontSize: 16, fontWeight: '700' }]}>Qualifications:</Text>
                        {qualificationsLines.map((line, index) => (
                          <View style={{ flexDirection: "row", width: '90%' }}>
                            <Text style={[Styles.TextStyle2, { fontSize: 16, marginLeft: 5 }]} key={index}>{'\u2022'}</Text>
                            <Text style={[Styles.TextStyle2, { fontSize: 16, marginLeft: 8.5 }]}>{line.trim()}</Text>
                          </View>
                        ))}
                      </View>

                      <View style={{ flexDirection: 'column', gap: 0 }}>
                        <Text style={[Styles.TextStyle2, { fontSize: 16, fontWeight: '700' }]}>Skills:</Text>
                        {SkillsLines.map((line, index) => (
                          <View style={{ flexDirection: "row", width: '90%' }}>
                            <Text style={[Styles.TextStyle2, { fontSize: 16, marginLeft: 5 }]} key={index}>{'\u2022'}</Text>
                            <Text style={[Styles.TextStyle2, { fontSize: 16, marginLeft: 8.5 }]}>{line.trim()}</Text>
                          </View>
                        ))}
                      </View>
                    </View>
                  </View>

                  {/* upload cv */}
                  <View style={{ flexDirection: 'column', gap: 16 }}>
                    <Text style={[Styles.TextStyle2]}>
                      Upload your CV for consideration.
                    </Text>
                    <View style={{ flexDirection: "row", gap: 5 }}>
                      <TouchableOpacity onPress={this.pickCvDocument} style={{ borderRadius: 4, padding: 2, backgroundColor: 'lightgrey', borderWidth: 1, borderColor: 'black' }}>
                        <Text style={{ fontSize: 12 }}>{"Choose file"}</Text>
                      </TouchableOpacity>
                      <Text style={{ fontSize: 12, paddingTop: 2 }}>{this.state.cvToUpload ? this.state.cvToUpload.name : "No file chosen"}</Text>
                    </View>


                    <View style={{ alignSelf: "flex-start" }}>
                      {this.renderApplyCvButton('Apply', 'Apply Now', this.postCvDocument, { letterSpacing: 1.25 })}
                    </View>
                    {this.state.cvUploaded && <Text style={[Styles.TextStyle2, { color: '#4D7F3B' }]}> ✓ You’ve successfully submitted your CV </Text>}

                  </View>



                </View>
              </Animatable.View>
            </ScrollView>
          </Pressable>
        </Pressable>
      </Animatable.View>
    );

    const jobDetailsItems = this.state.jobOpenings.map(
      (item, index) => {
        const isSelected = this.state.jobOpeningPos == index;
        const lines = item.DUTIES.split('#^');
        const qualificationsLines = item.QUALIFICATIONS.split('#^');
        const SkillsLines = item.SKILLS.split('#^');
        const itemNo = index;

      }
    );
    return (<View style={{
      marginTop: marginTop - 300,
      width,
      marginLeft: width * 0.1,
      height: height,
    }}>
      {jobDetailsItems}
    </View>
    )
  }

  renderJobDialogMobile = () => {
    if (this.state.jobOpenings.length == 0) {
      return <View></View>;
    }
    const item = this.state.jobOpenings[this.state.jobOpeningPos];
    const lines = item.DUTIES.split('#^');
    const qualificationsLines = item.QUALIFICATIONS.split('#^');
    const SkillsLines = item.SKILLS.split('#^');
    return (
      <Animatable.View
        ref={el => (this.jobDetailsDialog = el)}
        style={[{
          opacity: 0, position: "fixed",
          zIndex: this.state.showjobDetailsDialog ? 9 : 0, width: '100%', height: '100%',
          background: 'white'
        }]}>
        <Header
          title={STRINGS.company_name}
          leftView={Styles.drawerButtonDark(this.props.navigation)}
          light={true}
          navigation={this.props.navigation}
          hideHeader={this.state.hideHeader}
          hideScrollTopButton={this.state.hideScrollTopButton}
          self={this}
          selectedTab={""}
        />
        <Pressable style={{
          flex: 1,
          cursor: ''
        }} onPress={this.closeJobDialog}>

          <Pressable style={{
            cursor: ''
          }} >
            {Styles.renderVSeparator(88)}
            <TouchableOpacity onPress={this.closeJobDialog} style={{ position: "absolute", zIndex: 999, right: 40, top: 132 }}>
              <Image source={xIcon} style={{ height: 12, width: 12 }} />
            </TouchableOpacity>

            <ScrollView
              ref={ref => this.mainScrollView = ref}
              style={{ height: height - 88 }}
              scrollEventThrottle={200} showsVerticalScrollIndicator={true}
            >
              <Animatable.View style={{ backgroundColor: White, minHeight: height - 88, paddingHorizontal: 20, paddingTop: 80 }} >
                <View style={{ flexDirection: 'column', gap: 56 }}>
                  <View style={{ flexDirection: 'column', gap: 26 }}>
                    <Text style={[Styles.TextStyle3]}>{item.JOBTITLE}</Text>
                    <View style={{ flexDirection: 'row', gap: isMobile ? 25 : 76 }}>
                      <View style={{ flexDirection: 'column', gap: 8.5 }}>
                        <View style={{ flexDirection: 'row', gap: 6, alignItems: "center" }}>
                          <Image source={imgLocation} style={{ height: isMobile ? 7.703 : 11.89, width: isMobile ? 6.029 : 9.305 }} resizeMode="contain" />
                          <Text style={[Styles.TextStyle2, { fontSize: isMobile ? 10.366 * scale : 16, fontWeight: '400', letterSpacing: 0.08 }]}>Location</Text>
                        </View>
                        <Text style={[Styles.TextStyle2, { fontSize: isMobile ? 10.366 * scale : 16, fontWeight: '700', width: isMobile ? 60 : 120 }]}>{item.LOCATION}</Text>
                      </View>

                      <View style={{ flexDirection: 'column', gap: 8.5 }}>
                        <View style={{ flexDirection: 'row', gap: 6, alignItems: "center" }}>
                          <Image source={imgDepartment} style={{ height: isMobile ? 6.67 : 10.296, width: isMobile ? 8.952 : 13.817 }} resizeMode="contain" />
                          <Text style={[Styles.TextStyle2, { fontSize: isMobile ? 10.366 * scale : 16, fontWeight: '400', letterSpacing: 0.08 }]}>Department</Text>
                        </View>
                        <Text style={[Styles.TextStyle2, { fontSize: isMobile ? 10.366 * scale : 16, fontWeight: '700', width: isMobile ? 60 : 120 }]}>{item.DEPARTMENT}</Text>
                      </View>

                      <View style={{ flexDirection: 'column', gap: 8.5 }}>
                        <View style={{ flexDirection: 'row', gap: 6, alignItems: "center" }}>
                          <Image source={imgModality} style={{ height: isMobile ? 7.659 : 11.822, width: isMobile ? 7.404 : 11.428 }} resizeMode="contain" />
                          <Text style={[Styles.TextStyle2, { fontSize: isMobile ? 10.366 * scale : 16, fontWeight: '400', letterSpacing: 0.08 }]}>Modality</Text>
                        </View>
                        <Text style={[Styles.TextStyle2, { fontSize: isMobile ? 10.366 * scale : 16, fontWeight: '700', width: isMobile ? 60 : 120 }]}>{item.MODALITY}</Text>
                      </View>
                      <View style={{ flexDirection: 'column', gap: 8.5 }}>
                        <View style={{ flexDirection: 'row', gap: 6, alignItems: "center" }}>
                          <Image source={imgSalary} style={{ height: isMobile ? 8.317 : 12.838, width: isMobile ? 13.055 : 20.15 }} resizeMode="contain" />
                          <Text style={[Styles.TextStyle2, { fontSize: isMobile ? 10.366 * scale : 16, fontWeight: '400', letterSpacing: 0.08 }]}>Salary</Text>
                        </View>
                        <Text style={[Styles.TextStyle2, { fontSize: isMobile ? 10.366 * scale : 16, fontWeight: '700', width: isMobile ? 60 : 120 }]}>{item.SALARY}</Text>
                      </View>

                    </View>


                    {/* jobDescription view */}
                    <View style={{ flexDirection: 'column', gap: 34, marginTop: 40 }}>
                      <Text style={[Styles.TextStyle3]}>Job Description</Text>
                      <View style={{ flexDirection: 'column', gap: 0 }}>
                        <Text style={[Styles.TextStyle2, { fontWeight: '700' }]}>Duties & Responsibilities:</Text>
                        {lines.map((line, index) => (
                          <View style={{ flexDirection: "row", width: '90%' }}>
                            <Text style={[Styles.TextStyle2, { marginLeft: 5 }]} key={index}>{'\u2022'}</Text>
                            <Text style={[Styles.TextStyle2, { marginLeft: 8.5 }]}>{line.trim()}</Text>
                          </View>
                        ))}
                      </View>

                      <View style={{ flexDirection: 'column', gap: 0 }}>
                        <Text style={[Styles.TextStyle2, { fontWeight: '700' }]}>Qualifications:</Text>
                        {qualificationsLines.map((line, index) => (
                          <View style={{ flexDirection: "row", width: '90%' }}>
                            <Text style={[Styles.TextStyle2, { marginLeft: 5 }]} key={index}>{'\u2022'}</Text>
                            <Text style={[Styles.TextStyle2, { marginLeft: 8.5 }]}>{line.trim()}</Text>
                          </View>
                        ))}
                      </View>

                      <View style={{ flexDirection: 'column', gap: 0 }}>
                        <Text style={[Styles.TextStyle2, { fontWeight: '700' }]}>Skills:</Text>
                        {SkillsLines.map((line, index) => (
                          <View style={{ flexDirection: "row", width: '90%' }}>
                            <Text style={[Styles.TextStyle2, { marginLeft: 5 }]} key={index}>{'\u2022'}</Text>
                            <Text style={[Styles.TextStyle2, { marginLeft: 8.5 }]}>{line.trim()}</Text>
                          </View>
                        ))}
                      </View>
                    </View>
                  </View>

                  {/* upload cv */}
                  <View style={{ flexDirection: 'column', gap: 16 }}>
                    <Text style={[Styles.TextStyle2]}>
                      Upload your CV for consideration.
                    </Text>
                    <View style={{ flexDirection: "row", gap: 5 }}>
                      <TouchableOpacity onPress={this.pickCvDocument} style={{ borderRadius: 4, padding: 2, backgroundColor: 'lightgrey', borderWidth: 1, borderColor: 'black' }}>
                        <Text style={{ fontSize: 12 }}>{"Choose file"}</Text>
                      </TouchableOpacity>
                      <Text style={{ fontSize: 12, paddingTop: 2 }}>{this.state.cvToUpload ? this.state.cvToUpload.name : "No file chosen"}</Text>
                    </View>

                    <View style={{ alignSelf: "flex-start" }}>
                      {this.renderApplyCvButton('Apply', 'Apply Now', this.postCvDocument, { letterSpacing: 1.25 })}
                    </View>
                    {this.state.cvUploaded && <Text style={[Styles.TextStyle2, { color: '#4D7F3B' }]}> ✓ You’ve successfully submitted your CV </Text>}

                  </View>
                </View>
              </Animatable.View>
              {Styles.renderVSeparator(50)}
              {Commons.renderFooter({}, this)}
            </ScrollView>
          </Pressable>
        </Pressable>
      </Animatable.View>
    );

    const jobDetailsItems = this.state.jobOpenings.map(
      (item, index) => {
        const isSelected = this.state.jobOpeningPos == index;
        const lines = item.DUTIES.split('#^');
        const qualificationsLines = item.QUALIFICATIONS.split('#^');
        const SkillsLines = item.SKILLS.split('#^');
        const itemNo = index;

      }
    );
    return (<View style={{
      marginTop: marginTop - 300,
      width,
      marginLeft: width * 0.1,
      height: height,
    }}>
      {jobDetailsItems}
    </View>
    )
  }


  renderPart4 = () => {
    var marginLeft = width - 1336;
    if (marginLeft < 60) {
      marginLeft = 60;
    }
    return (<View style={{
      width,
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      marginTop: width / 8.235,
      flexDirection: 'column',
      gap: 30,
      marginTop: 90,
      paddingLeft: 160,
    }}>
      <Text style={[Styles.TextStyle2]}>
        Upload your CV for consideration. We'll be in touch if
        {'\n'}there are any suitable opportunities.
      </Text>

      <View style={{ display: 'flex', width: 597, flexDirection: 'column', alignItems: 'flex-start', gap: 8 }}>
        <Text style={[Styles.TextStyle2, { fontSize: 18, color: 'red' }]}>
          *
          <Text style={[Styles.TextStyle2]}>Choose Department</Text>
        </Text>
        <Dropdown style={{
          width: 401, height: 36.034, marginLeft: 1,
          borderRadius: 30, borderColor: '#D4D4D8', borderWidth: 1,
          paddingLeft: 10
        }}
          inputSearchStyle={styles.inputSearchStyle}
          searchPlaceholder="Search Job Openings..."
          search
          labelField="label"
          valueField="value"
          placeholder=""
          value={this.state.department}
          data={dropDownListItems}
          onChange={(text) => this.setState({ department: (text.value) })}
        />
        <View style={{ flexDirection: "row", gap: 5, marginLeft: 5, marginTop: 5, height: 22, justifyContent: 'center', }}>
          <TouchableOpacity onPress={this.pickDocument} style={{ borderRadius: 4, padding: 2, backgroundColor: 'lightgrey', borderWidth: 1, borderColor: 'black' }}>
            <Text style={{ fontSize: 12 }}>{"Choose file"}</Text>
          </TouchableOpacity>
          <Text style={{ fontSize: 12, paddingTop: 2 }}>{this.state.fileToUpload ? this.state.fileToUpload.name : "No file chosen"}</Text>
        </View>
      </View>

      <View style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 8, textAlign: 'left' }}>
        <Checkbox style={{ alignSelf: 'center' }}
          value={this.state.agree}
          onValueChange={(agree) => { this.setState({ agree }) }}
          color={this.state.agree ? "#4630EB" : undefined} />
        <Text style={[Styles.TextStyle2, { fontSize: 11.52, color: 'red' }]}>
          *
          <Text style={[Styles.TextStyle2, { fontSize: 11.52, width: 420 }]}>
            I hereby grant permission to Jordan Drugstore Co. and its affiliated entities {'\n'}for the collection and processing of my personal information in
            alignment with the{'\n'}Regional Privacy Policy.
          </Text>
        </Text>
      </View>

      <Pressable disabled={!this.state.fileToUpload || !this.state.department || !this.state.agree}>
        {this.renderPressableButton('myUpload', 'Upload', this.postDocument)}
      </Pressable>
      {this.state.uploaded && <Text style={[Styles.TextStyle2, { color: '#4D7F3B' }]}> ✓ You’ve successfully submitted your CV </Text>}

    </View>)
  }

  renderPart4Mobile = () => {
    return (<View style={{
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      flexDirection: 'column',
      gap: 24,
    }}>
      <Text style={[Styles.TextStyle2]}>
        Upload your CV for consideration. We'll be in touch if there are any suitable opportunities.
      </Text>

      <View style={{ display: 'flex', width: 597, flexDirection: 'column', alignItems: 'flex-start', gap: 8 }}>
        <Text style={[Styles.TextStyle2, { fontSize: 18, color: 'red' }]}>
          *
          <Text style={[Styles.TextStyle2]}>Choose Department</Text>
        </Text>
        <Dropdown style={{
          width: width - 40, height: 36.034, marginLeft: 1,
          borderRadius: 30, borderColor: '#D4D4D8', borderWidth: 1,
          paddingLeft: 10
        }}
          inputSearchStyle={styles.inputSearchStyle}
          searchPlaceholder="Search Job Openings..."
          search
          labelField="label"
          valueField="value"
          placeholder=""
          value={this.state.department}
          data={dropDownListItems}
          onChange={(text) => this.setState({ department: (text.value) })}
        />
        <View style={{ flexDirection: "row", gap: 5, marginLeft: 5, marginTop: 5, height: 22, justifyContent: 'center', }}>
          <TouchableOpacity onPress={this.pickDocument} style={{ borderRadius: 4, padding: 2, backgroundColor: 'lightgrey', borderWidth: 1, borderColor: 'black' }}>
            <Text style={{ fontSize: 12 }}>{"Choose file"}</Text>
          </TouchableOpacity>
          <Text style={{ fontSize: 12, paddingTop: 2 }}>{this.state.fileToUpload ? this.state.fileToUpload.name : "No file chosen"}</Text>
        </View>
      </View>
      <View style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 8, textAlign: 'left' }}>
        <Checkbox style={{ alignSelf: 'center' }}
          value={this.state.agree}
          onValueChange={(agree) => { this.setState({ agree }) }}
          color={this.state.agree ? "#4630EB" : undefined} />
        <Text style={[Styles.TextStyle2, { fontSize: 11.52, color: 'red' }]}>
          *
          <Text style={[Styles.TextStyle2, { fontSize: 11.52, width: 420 }]}>
            I hereby grant permission to Jordan Drugstore Co. and its affiliated entities for the collection and processing of my personal information in
            alignment with the Regional Privacy Policy.
          </Text>
        </Text>
      </View>
      <View style={{ width: width - 40 }}>
        {this.renderPressableButton('myUpload', 'Upload', this.postDocument)}
      </View>
      {this.state.uploaded && <Text style={[Styles.TextStyle2, { color: '#4D7F3B' }]}> ✓ You’ve successfully submitted your CV </Text>}
      <View style={{ height: 0 }}></View>

    </View>)

  }

  pickDocument = async () => {
    try {
      const self = this;
      // const result = await DocumentPicker.getDocumentAsync({});
      document.getElementById('select').addEventListener('change', function (e) {
        if (e.target.files[0]) {
          const fileToUpload = e.target.files[0];
          self.setState({ fileToUpload, uploaded: false });
        }
      });

      document.getElementById('select').click();
    } catch (error) {
      console.error(error);
    }

  }



  postDocument = async () => {
    const fileToUpload = this.state.fileToUpload;
    const name = this.state.department + "_" + moment(new Date()).format('YYYYMMDDHHMMSS') + "_" + fileToUpload.name;
    const response = await ServerOperations.pickUploadHttpRequest(fileToUpload, name);
    if (response === Constants.networkError_code) {
      this.setState({ uploaded: false });
    }
    if (response.ok) {
      const resp = await response.json();
      this.setState({ uploaded: resp.PATH, fileToUpload: undefined });
    }
  }

  pickCvDocument = async () => {
    try {
      const self = this;
      // const result = await DocumentPicker.getDocumentAsync({});
      document.getElementById('select').addEventListener('change', function (e) {
        if (e.target.files[0]) {
          const cvToUpload = e.target.files[0];
          self.setState({ cvToUpload, cvUploaded: false });
        }
      });

      document.getElementById('select').click();
    } catch (error) {
      console.error(error);
    }

  }

  postCvDocument = async () => {
    const item = this.state.jobOpenings[this.state.jobOpeningPos];
    const cvToUpload = this.state.cvToUpload;
    const name = "jobs\\" + item.ID + "\\" + moment(new Date()).format('YYYYMMDDHHMMSS') + "_" + cvToUpload.name;
    const response = await ServerOperations.pickUploadHttpRequest(cvToUpload, name);
    if (response === Constants.networkError_code) {
      this.setState({ cvUploaded: false });
    }
    if (response.ok) {
      const resp = await response.json();
      this.setState({ cvUploaded: resp.PATH, cvToUpload: undefined });
    }
  }


  styles = () => ({
    container: {
      flex: 1,
      width: width,
      paddingVertical: 0,
      paddingHorizontal: isMobile ? 0 : 164,
      alignItems: "center",
      gap: isMobile ? 0 : 100,
      backgroundColor: WHITE,
    },
    image: {
      resizeMode: 'contain',
      height: 584,
      width: width,
      marginTop: marginTop - 200,
    },
    jobContainer: {
      width: 1120,
      height: 103.444,
      justifyContent: 'center',
      alignItems: 'flex-start',
      boxShadow: '15.556px 15.556px 15.556px 0px rgba(0, 0, 0, 0.25)',
      borderRadius: 38.889,
      marginLeft: 164,
    },
  });
}



export default Careers;
